import { render } from "./BinLabels.vue?vue&type=template&id=1ebdd410"
import script from "./BinLabels.vue?vue&type=script&lang=js"
export * from "./BinLabels.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__